import { HttpClient } from "@angular/common/http";
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import {MatDialog as MatDialog,MatDialogRef as MatDialogRef } from "@angular/material/dialog";
import {MatPaginator as MatPaginator } from "@angular/material/paginator";
import {MatSelect as MatSelect } from "@angular/material/select";
import {MatTableDataSource as MatTableDataSource } from "@angular/material/table";
import {
  FormArray,
  UntypedFormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { log } from "console";
import { DataSourceService } from "src/app/services/data-source.service";
import { catchError, map } from "rxjs/operators";
import { EMPTY, from, of } from "rxjs";

@Component({
  selector: "app-submitted-forms",
  templateUrl: "./submitted-forms.component.html",
  styleUrls: ["./submitted-forms.component.css"],
})
export class SubmittedFormsComponent implements OnInit, OnDestroy {
  // #Forms
  advanceFilterForm = new FormGroup({
    selectedForm: new FormControl(null, Validators.required),
    selectedFormItem: new FormControl(null, Validators.required),
    selectedFormItemName: new FormControl(null),
    formType: new FormControl(null),
    optionField: new FormControl(null),
  });

  searchCriteriaForm = new FormGroup({
    searchArray: new FormArray([]),
  });
  //

  // #ViewChilds Refrences
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("detailsDialog", { static: true }) detailsDialog: TemplateRef<any>;
  @ViewChild("filterDialog", { static: true }) filterDialog: TemplateRef<any>;
  @ViewChild("confirmDialog", { static: true }) confirmDialog: TemplateRef<any>;
  @ViewChild("formSelect", { static: false }) formSelect: MatSelect;
  //
  private dialogRef: MatDialogRef<any>; // For Confirmation Modal .

  filterForm: FormGroup;
  formTypes: { key: number; value: string }[] = [];
  comparisonOperators: { key: number; value: string }[] = [];
  selectedDetails: [];
  selectedTempForm: any = null;
  displayedColumns: string[] = [
    "formItemName",
    "fullName",
    "result",
    "type",
    "creationDate",
    "viewDetails",
  ];
  dataSource = new MatTableDataSource();
  modalRef: BsModalRef;
  index: number = 0;
  size: number = 10; // Initial page size
  dataLength: number;
  appliedFilter = [];
  CreteriaInputTypes = EPricingCriteriaInputTypes; // to use in HTML

  //
  isSubmittedFormsLoading: boolean = true;
  //
  allForms = [];
  formFieldsItems = [];
  isOptionType: boolean = false;
  fieldOptionValues = [];
  prevFormResult = {
    id: null,
    items: [],
  };

  // SelectedForm (For fetch data on scroll) .
  isFormItemsWithClassificationLoading = false;
  isFetchingMore = false; // New flag to indicate loading during scroll
  currentPageForScroll = 0;
  pageSizeForScroll = 10;
  hasMoreRecords = true;
  //
  constructor(
    private httpClient: HttpClient,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog, // Inject MatDialog
    private dataSoruceService: DataSourceService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.getAllFormItems(true);
  }

  closeFilterModal(applyFilter = false) {
    // if (this.searchCriteriaForm.invalid) {
    //   this.searchCriteriaForm.markAllAsTouched();
    //   return;
    // }

    if (!applyFilter) {
      this.clearFilters();
    }
    this.dialog.closeAll();
    this.removeScrollListener();
    //  setFilters
  }

  openFilterModal() {
    const dialogRef = this.dialog.open(this.filterDialog, {
      width: "1000px",
    });

    dialogRef.afterOpened().subscribe(() => {
      // Add Scroll listener .
      this.addScrollListener();
    });
  }

  parseDateAsUTC(dateString) {
    // Explicitly parse the date string in UTC format
    const date = new Date(dateString);
    // Ensure the date is interpreted in UTC
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date;
  }

  getStartOfDay(dateString) {
    const date = this.parseDateAsUTC(dateString);
    // Set time to the start of the day (00:00:00) in UTC
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

  getEndOfDay(dateString) {
    const date = this.parseDateAsUTC(dateString);
    // Set time to the end of the day (23:59:59.999) in UTC
    date.setUTCHours(23, 59, 59, 999);
    return date;
  }

  initForm() {
    this.getTypes();
    this.filterForm = this.fb.group({
      // formItemName: [""],
      fullName: [""],
      type: [""],
      fromDate: [""],
      toDate: [""],
    });

    this.getAll(this.index, this.size); // Fetch initial data with pagination
  }

  getTypes() {
    this.formTypes = Object.keys(FormItemType)
      .filter((key) => isNaN(Number(key))) // Filter out the numeric keys
      .map((key) => ({
        key: FormItemType[key],
        value: key,
      }));

    this.comparisonOperators = Object.keys(EComparisonOperators)
      .filter((key) => isNaN(Number(key))) // Filter out the numeric keys
      .map((key) => ({
        key: EComparisonOperators[key],
        value: key,
      }));
  }

  displayFormType(type) {
    const foundItem = this.formTypes.find((el) => el.key == type);
    return foundItem && foundItem.value ? foundItem.value : "-";
  }

  onValueChange(fg) {
    console.log(this.comparisonOperators, "Comp...");
    console.log(fg, "Comp...");
  }

  applyFilter() {
    // Apply the filter logic here, e.g., calling the backend with filterValues
    this.index = 0;
    this.getAll(this.index, this.size);
  }

  applyFilterFromModal() {
    console.log(this._searchArray);
    if (this.searchCriteriaForm.invalid) {
      this.searchCriteriaForm.markAllAsTouched();
      return;
    }

    this.appliedFilter = this._searchArray.value;
    this.index = 0;
    this.getAll(this.index, this.size);
    this.closeFilterModal(true);
  }

  clearFilter() {
    this.filterForm.reset();
    this.index = 0;
    this.getAll(this.index, this.size); // Reload data without filters
  }

  getAll(pageIndex: number, pageSize: number) {
    //
    this.isSubmittedFormsLoading = true;
    const appliedConditions = this.appliedFilter.length
      ? this.appliedFilter.map((el) => {
          return (el = {
            formFieldId: el.key,
            comparisonOperators: el.comp,
            searchValue: el.value,
          });
        })
      : [];
    //
    const requestBody = {
      ...this.filterForm.value,
      FullName: this.filterForm.value.fullName || "",
      PageNumber: pageIndex,
      PageSize: pageSize,
      conditions: appliedConditions,
      fromDate: this.filterForm.value.fromDate
        ? this.getStartOfDay(this.filterForm.value.fromDate)
        : "",
      toDate: this.filterForm.value.toDate
        ? this.getEndOfDay(this.filterForm.value.toDate)
        : "",
    };

    this.httpClient
      .post("/DynamicFormsAPI/GetSubmission", requestBody)
      .pipe(
        catchError((err) => {
          this.isSubmittedFormsLoading = false;
          return EMPTY;
        })
      )
      .subscribe((res: any) => {
        this.dataSource = new MatTableDataSource(res.data);

        this.dataLength = res.totalCount; // Set the total count for pagination
        this.isSubmittedFormsLoading = false;
        // this.dataSource.paginator = this.paginator; // Attach paginator
      });
    // ...

    // ...
  }

  // Event handler for page change
  onPageChange(event: any) {
    console.log(event, "Event .");

    this.index = event.pageIndex;
    this.size = event.pageSize;
    this.getAll(this.index, this.size); // Fetch new data when page changes
  }

  openDetails(element: any) {
    console.log(element, "El ?");

    this.selectedDetails =
      element && element.submissionInfo ? element.submissionInfo : [];

    const dialogRef = this.dialog.open(this.detailsDialog, {
      width: "600px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Dialog closed");
      this.selectedDetails = [];
    });
  }

  openFilterDialog() {
    const dialogRef = this.dialog.open(this.filterDialog, {
      width: "400px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Dialog closed");
      this.selectedDetails = [];
    });
  }

  getAllFormItems(isFirstLoad: boolean = false) {
    if (isFirstLoad) {
      this.listenToValueChanges();
    }

    if (!this.hasMoreRecords || this.isFormItemsWithClassificationLoading) {
      return;
    }

    this.isFormItemsWithClassificationLoading = true;
    this.isFetchingMore = true; // Show loader during fetch

    const url = `/Pricing/GetAllFormItemsWithClassificationPagination?page=${this.currentPageForScroll}&pageSize=${this.pageSizeForScroll}&SearchText=`;

    this.httpClient
      .get(url)
      .pipe(
        catchError((err) => {
          // Handle errors gracefully
          this.isFormItemsWithClassificationLoading = false;
          this.isFetchingMore = false; // Hide loader if fetch fails
          return EMPTY;
        })
      )
      .subscribe((res: any) => {
        const newForms = res.data;
        // Append new records to the existing list
        this.allForms = [...this.allForms, ...newForms];
        this.isFormItemsWithClassificationLoading = false;
        this.isFetchingMore = false; // Hide loader after fetch
        this.currentPageForScroll++;
        // Determine if more records can be fetched
        if (this.allForms.length >= res.totalCount) {
          this.hasMoreRecords = false;
        }
      });
  }

  onScroll() {
    // Check if scrolled to the bottom of the dropdown panel to trigger loading more items
    const panel =
      this.formSelect &&
      this.formSelect.panel &&
      this.formSelect.panel.nativeElement
        ? this.formSelect.panel.nativeElement
        : null;
    if (panel.scrollTop + panel.clientHeight >= panel.scrollHeight) {
      this.getAllFormItems();
    }
  }

  addScrollListener() {
    // Attach scroll event listener only if the panel exists

    if (this.formSelect) {
      this.formSelect.openedChange.subscribe((isOpen) => {
        if (isOpen) {
          // Use setTimeout to ensure the panel is fully rendered
          setTimeout(() => {
            const panel =
              this.formSelect &&
              this.formSelect.panel &&
              this.formSelect.panel.nativeElement
                ? this.formSelect.panel.nativeElement
                : null;

            if (panel) {
              panel.addEventListener("scroll", this.onScroll.bind(this), {
                passive: true,
              });
            }
          }, 0);
        } else {
          this.removeScrollListener(); // Cleanup if the select is closed
        }
      });
    }
  }

  removeScrollListener() {
    // Remove the scroll event listener when the modal is closed
    const panel =
      this.formSelect &&
      this.formSelect.panel &&
      this.formSelect.panel.nativeElement
        ? this.formSelect.panel.nativeElement
        : null;
    if (panel) {
      panel.removeEventListener("scroll", this.onScroll.bind(this));
    }
  }

  listenToValueChanges() {
    this._selectedFormItemType.valueChanges.subscribe((res) => {
      if (res == EPricingCriteriaInputTypes.Option) {
        console.log("OPTION TYPE");
        this.isOptionType = true;
        this.getOptionValues();
        return;
      }
      this.isOptionType = false;
    });

    this._selectedFormItem.valueChanges.subscribe((res) => {
      this._optionField.setValue(null);
      this._optionField.clearValidators();
      this._optionField.updateValueAndValidity();

      this.fieldOptionValues = [];
      this.isOptionType = false;

      this._selectedFormItemName.setValue(
        res ? this.getFieldName(this.formFieldsItems, res) : ""
      );

      this._selectedFormItemType.setValue(
        res ? this.getFieldType(this.formFieldsItems, res) : ""
      );
    });

    this._selectedForm.valueChanges.subscribe((res) => {
      const selectedForm = this.allForms.find((el) => el.id == res);
      this.formFieldsItems =
        selectedForm && selectedForm.formFieldsItems
          ? selectedForm.formFieldsItems
          : [];

      if (res !== this.prevFormResult.id && this.prevFormResult.id) {
        this.showConfirmationModal().then((confirmed) => {
          if (confirmed) {
            console.log("Confirmed");
            this.prevFormResult = {
              id: res,
              items: this.formFieldsItems,
            };
            this.clearFilters();
          } else {
            // Rest Values .
            this._selectedForm.setValue(this.prevFormResult.id, {
              emitEvent: false,
            });
            this.formFieldsItems = this.prevFormResult.items;
            console.log("Cancel");
          }
        });
      } else {
        this.prevFormResult.id = res;
        this.prevFormResult.items = this.formFieldsItems;
      }
    });
  }

  getOptionValues() {
    if (!this.isOptionType) return;
    const oneOfOptionsType =
      this.tempSelectedOption && this.tempSelectedOption.oneOfOptionsType;
    console.log(this.tempSelectedOption, "GET OPT VALUES");

    switch (oneOfOptionsType) {
      case EDynamicFormsOneOfOptions.Manual:
        this.fieldOptionValues = this.getValuesFromManualOptions();
        this.setValidatorsIfNeeded();
        break;

      case EDynamicFormsOneOfOptions.DataSource:
        this.fetchDataSourceValues();
        break;

      case EDynamicFormsOneOfOptions.StaticApi:
        this.fetchStaticAPIValues();
        break;

      default:
        this.fieldOptionValues = [];
        break;
    }
  }

  clearFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  private setValidatorsIfNeeded() {
    if (this.fieldOptionValues && this.fieldOptionValues.length > 0) {
      this._optionField.setValidators([Validators.required]);
      this._optionField.updateValueAndValidity();
    }
  }

  private fetchDataSourceValues() {
    this.getValuesFromDataSourceApi().subscribe(
      (values) => {
        this.fieldOptionValues = values || [];
        this.setValidatorsIfNeeded();
      },
      (error) => this.handleError("Error fetching data source values", error)
    );
  }

  private fetchStaticAPIValues() {
    this.getValuesFromStaticAPI().subscribe(
      (values) => {
        this.fieldOptionValues = values || [];
        this.setValidatorsIfNeeded();
      },
      (error) => this.handleError("Error fetching static API values", error)
    );
  }

  private handleError(message: string, error: any) {
    console.error(message, error);
    this.fieldOptionValues = [];
  }

  getValuesFromManualOptions() {
    const formFieldDetails =
      this.tempSelectedOption && this.tempSelectedOption.formFieldDetails;
    if (Array.isArray(formFieldDetails) && formFieldDetails.length) {
      const category = formFieldDetails[0] && formFieldDetails[0].category;
      const children = category && category.children;
      if (Array.isArray(children) && children.length) {
        return children
          .map((child) =>
            Array.isArray(child.categoryDetails) && child.categoryDetails.length
              ? child.categoryDetails[0]
              : null
          )
          .filter((detail) => detail !== null);
      }
    }
    return [];
  }

  getValuesFromStaticAPI() {
    const formFieldDetails =
      this.tempSelectedOption && this.tempSelectedOption.formFieldDetails;
    const staticApiLink =
      Array.isArray(formFieldDetails) && formFieldDetails.length
        ? formFieldDetails[0].staticApiLink
        : null;

    if (!staticApiLink) {
      return of([]); // Return empty observable if the link is missing
    }

    const additionalInfoParsed = this.parseAdditionalInfo(
      formFieldDetails && formFieldDetails.length
        ? formFieldDetails[0].additionalInfo
        : null
    );

    // Use fetch instead of httpClient and convert the promise to an observable
    return from(
      fetch(staticApiLink)
        .then((response) => response.json())
        .then((res) => {
          if (Array.isArray(res)) {
            return this.mapKeyValuePairs(res, additionalInfoParsed);
          }
          return [];
        })
        .catch((error) => {
          this.handleError("Error fetching static API", error);
          return [];
        })
    );
  }

  getValuesFromDataSourceApi() {
    const formFieldDetails =
      this.tempSelectedOption && this.tempSelectedOption.formFieldDetails;

    if (!Array.isArray(formFieldDetails) || !formFieldDetails.length) {
      return of([]);
    }

    const { dataSourceId, additionalInfo } = formFieldDetails[0];
    const additionalInfoParsed = this.parseAdditionalInfo(additionalInfo);

    if (!dataSourceId) {
      return of([]); // Return empty observable if no dataSourceId
    }

    return this.invokeDataSource(dataSourceId).pipe(
      map((res) => {
        const responseArray = this.normalizeResponseArray(res);
        return this.mapKeyValuePairs(responseArray, additionalInfoParsed);
      }),
      catchError((error) => {
        this.handleError("Error fetching data source API", error);
        return of([]);
      })
    );
  }

  private parseAdditionalInfo(additionalInfo: any) {
    return typeof additionalInfo === "string"
      ? JSON.parse(additionalInfo)
      : additionalInfo || {};
  }

  private mapKeyValuePairs(res: any[], additionalInfo: any) {
    return res
      .map((item) => {
        const id = item && additionalInfo.key ? item[additionalInfo.key] : null;
        const name =
          item && additionalInfo.label ? item[additionalInfo.label] : null;

        if (id !== null && name !== null) {
          return { id, name };
        }

        return null;
      })
      .filter((pair) => pair !== null); // Filter out any null pairs
  }

  private normalizeResponseArray(res: any) {
    if (Array.isArray(res) && res.length > 0 && typeof res[0] === "object") {
      return res;
    } else if (typeof res === "object" && res !== null) {
      return [res];
    }
    return [];
  }

  invokeDataSource(dataSourceId: string, queryParamObj?: any) {
    const url = `/ApiInvoker/Invoke/${dataSourceId}`;
    const data = this.buildRequestBody(queryParamObj);
    return this.postData(url, data);
  }

  private buildRequestBody(queryParamObj?: any) {
    const data = { inputType: [] };
    if (queryParamObj) {
      Object.entries(queryParamObj).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          data[key] = value;
          data.inputType.push(key);
        }
      });
    }
    return data;
  }

  public postData(apiLink: string, requestBody: any) {
    return this.httpClient.post(apiLink, requestBody);
  }

  showConfirmationModal(): Promise<boolean> {
    return new Promise((resolve) => {
      this.dialogRef = this.dialog.open(this.confirmDialog);
      this.dialogRef.afterClosed().subscribe((confirmed) => {
        resolve(confirmed);
      });
    });
  }

  getFieldName(items, id) {
    if (!items.length || !id) return;
    const foundItem = items.find((el) => el.id == id);
    return foundItem ? foundItem.name : "";
  }

  tempSelectedOption: any = {};

  getFieldType(items, id) {
    if (!items.length || !id) return;
    const foundItem = items.find((el) => el.id == id);
    console.log(foundItem, "From Type ");
    this.tempSelectedOption = foundItem;
    return foundItem ? foundItem.type : "";
  }

  back() {
    window.history.back();
  }

  removeCriteria(index: number): void {
    this._searchArray.removeAt(index);
  }

  addSearchCreteria() {
    console.log(this._selectedFormItemName.value, "ADD_SEARCH CRITERIA!");

    const selectedItemType = this._selectedFormItemType.value; // Get the selected form item type
    const selectedOptionName = this.isOptionType
      ? this.getOptionNameById(this._optionField.value) // Get the selected option name if it's an option type
      : "";

    if (this.advanceFilterForm.invalid) {
      this.advanceFilterForm.markAllAsTouched();
      return;
    }

    const formGroup = new FormGroup({
      key: new FormControl(this._selectedFormItem.value),
      comp: new FormControl(null, Validators.required),
      value: new FormControl(
        selectedOptionName,
        this.getValidatorsByType(selectedItemType)
      ), // Set value directly without disabling
      name: new FormControl(
        this._selectedFormItemName.value || "",
        Validators.required
      ),
      type: new FormControl(selectedItemType), // Store the field type to use for rendering
    });

    this._searchArray.push(formGroup);
    console.log(this._searchArray.value, "Search Array.");
  }

  private getOptionNameById(optionId: number): string {
    const selectedOption = this.fieldOptionValues.find(
      (option) => option.id === optionId
    );
    return selectedOption ? selectedOption.name : "";
  }

  // Helper method to determine validators based on type
  private getValidatorsByType(type: EPricingCriteriaInputTypes) {
    switch (type) {
      case EPricingCriteriaInputTypes.Number:
      case EPricingCriteriaInputTypes.PhoneNumber:
        return [Validators.required, Validators.pattern(/^\d+$/)]; // Numeric validation
      case EPricingCriteriaInputTypes.Email:
        return [Validators.required, Validators.email]; // Email validation
      case EPricingCriteriaInputTypes.Date:
        return [Validators.required]; // Date validation handled by datepicker component
      default:
        return [Validators.required]; // Default validation for other types
    }
  }

  clearFilters(clearAll = false) {
    this._selectedFormItem.setValue(null);
    this.clearFormArray(this._searchArray);
    this.searchCriteriaForm.reset();
    this.searchCriteriaForm.updateValueAndValidity({ emitEvent: false });
    this.appliedFilter = [];
    this.isOptionType = false;
    this.fieldOptionValues = [];
    if (clearAll) {
      this.prevFormResult.id = null;
      this.prevFormResult.items = [];
      this.advanceFilterForm.reset();
      this.advanceFilterForm.updateValueAndValidity({ emitEvent: false });
      this.filterForm.reset();
      this.filterForm.updateValueAndValidity();
      this.index = 0;
      this.getAll(this.index, this.size);
    }
  }

  onConfirm() {
    // const dialogRef = this.dialog.open(this.confirmDialog);
    this.dialogRef.close(true);
  }

  closeConfirmation() {
    this.dialogRef.close(false);
  }

  // #Getters
  get _selectedForm() {
    return this.advanceFilterForm.get("selectedForm");
  }

  get _optionField() {
    return this.advanceFilterForm.get("optionField");
  }

  get _selectedFormItem() {
    return this.advanceFilterForm.get("selectedFormItem");
  }
  get _selectedFormItemName() {
    return this.advanceFilterForm.get("selectedFormItemName");
  }

  get _selectedFormItemType() {
    return this.advanceFilterForm.get("formType");
  }

  get _searchArray() {
    return <FormArray>this.searchCriteriaForm.get("searchArray");
  }

  ngOnDestroy(): void {
    this.removeScrollListener();
  }
}

// #Enums
export enum FormItemType {
  PricingQuotation = 1,
  Survey = 2,
  Workflow = 3,
}

export enum EPricingCriteriaInputTypes {
  Text = 1,
  Number = 2,
  Currency = 3,
  Option = 4,
  Date = 5,
  Email = 6,
  PhoneNumber = 7,
  Attachment = 8,
  TextArabic = 9,
  TextEnglish = 10,
}

export enum EComparisonOperators {
  Equal = 1,
  NotEqual = 2,
  GreaterThan = 3,
  LessThan = 4,
  GreaterThanOrEqual = 5,
  LessThanOrEqual = 6,
}

export enum EDynamicFormsOneOfOptions {
  Manual = 1,
  DataSource = 2,
  StaticApi = 3,
}
